export enum BusinessTransportPolicyType {
  FLAT_RATE = 'FLAT_RATE',
  SUBSCRIPTION = 'SUBSCRIPTION',
}

export const getBusinessTransportPolicyTypeLabel = (
  type: BusinessTransportPolicyType
): string => {
  switch (type) {
    case BusinessTransportPolicyType.FLAT_RATE:
      return $localize`Police à forfait`;
    case BusinessTransportPolicyType.SUBSCRIPTION:
      return $localize`Police d'abonnement`;
    default:
      return type;
  }
};
